import React, { useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import InvoiceCard from "../../components/InvoiceCard/InvoiceCard";
import { createInvoice } from "../../redux/actions/CreateInvoice";
import { RootState } from "../../redux/rootReducers";
import ThemeContext from "../../ThemeContext";
import Layout from "../Layout/Layout";
import "./InvoiceSummary.scss";
import { v4 as uuidv4 } from "uuid";

const InvoiceSummary: React.FC = () => {
  const navigate = useNavigate();
  const { merchantId } = useParams<{ merchantId: string }>();
  const dispatch = useDispatch();
  const themes = useContext(ThemeContext);
  const showRecurringCard = themes?.projects?.recurringPayment === true;
  const authApi = useSelector((state: RootState) => state.authReducer);
  const invoiceSummary = useSelector(
    (state: RootState) => state.invoiceSummary.invoiceSummary,
  );

  const merchant: any = useSelector(
    (state: RootState) => state.merchantReducer,
  );
  const idempotencyKey = useRef<string>(uuidv4()).current;

  const invoiceData = {
    totalItems: invoiceSummary?.totalItems,
    SubTotal: invoiceSummary?.SubTotal,
    taxVATAmount: invoiceSummary?.taxVATAmount,
    subTotalWithVat: invoiceSummary?.subTotalWithVat,
    discount: invoiceSummary?.Discount,
    Shipping: invoiceSummary?.Shipping,
    InvoiceTotal: invoiceSummary?.InvoiceTotal,
  };

  const isRecurringEnabledForCurrentMerchant =
    merchant?.merchantData && merchant?.merchantData?.recurringEnabled;
  const isPayByLinkEnabledForCurrentMerchant =
    merchant?.merchantData && merchant?.merchantData?.payByLinkEnabled;

  const handlePayNow = async () => {
    await dispatch(
      createInvoice(
        authApi.token,
        invoiceSummary.merchantId,
        authApi.userId,
        invoiceSummary.customer.id,
        new Date(),
        invoiceSummary.customer.name,
        invoiceSummary.customer.email,
        invoiceSummary.customer.phoneNum,
        invoiceSummary.customer.address,
        invoiceSummary.customer.language,
        invoiceSummary.customer.vatId,
        invoiceSummary.products,
        invoiceSummary.sendBy,
        false,
        invoiceSummary?.totalItems,
        invoiceSummary?.SubTotal,
        invoiceSummary?.taxVATAmount,
        invoiceSummary?.subTotalWithVat,
        invoiceSummary?.Discount,
        invoiceSummary?.Shipping,
        invoiceSummary?.InvoiceTotal,
        invoiceSummary?.description,
        idempotencyKey,
        invoiceSummary?.customer?.customerType,
        invoiceSummary?.customer?.accountNumber,
        invoiceSummary?.customer?.bankName,
        invoiceSummary?.customer?.nationalId,
        invoiceSummary?.customer?.nationalIdIssueDate,
        invoiceSummary?.customer?.nationalIdIssuePlace,
        invoiceSummary?.customer?.legalForm,
        invoiceSummary?.customer?.capitalAmount,
        invoiceSummary?.customer?.registrationNumber,
        invoiceSummary?.customer?.fiscalId,
      ),
    );
    navigate(`/merchant/${invoiceSummary.merchantId}/invoice/invoiceList`, {
      replace: true,
    });
  };

  const handleSetUpRecurring = () => {
    navigate(
      `../merchant/${invoiceSummary.merchantId}/invoice/new/recurringPayment`,
      {
        replace: true,
      },
    );
  };

  return (
    <Layout type="merchant">
      <div className="content-side" style={{ display: "block" }}>
        <div className="einvoice-page">
          <div className="container">
            <div
              className="row g-4"
              style={{
                display: "flex",
                justifyContent: showRecurringCard ? "flex-start" : "center",
                alignItems: "flex-start",
              }}
            >
              {/* Left Column - Payment Invoice Card */}
              {isPayByLinkEnabledForCurrentMerchant === true && (
                <div
                  className="col-lg-6"
                  style={{
                    maxWidth: "600px",
                    flex: showRecurringCard
                      ? "1 1 calc(50% - 12px)"
                      : "0 1 600px",
                  }}
                >
                  <InvoiceCard
                    invoiceData={invoiceData}
                    type="payment"
                    onPayNow={handlePayNow}
                  />
                </div>
              )}
              {/* Right Column - Recurring Payment Invoice Card */}
              {isRecurringEnabledForCurrentMerchant === true && (
                <div
                  className="col-lg-6"
                  style={{
                    maxWidth: "600px",
                    flex: "1 1 calc(50% - 12px)",
                  }}
                >
                  <InvoiceCard
                    invoiceData={invoiceData}
                    type="recurring"
                    onSetUpRecurring={handleSetUpRecurring}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default InvoiceSummary;
